import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navbar.css';
import GeneLogo from './Logo/GeneLogo';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo" onClick={closeMenu}>
          <GeneLogo size="normal" showTagline={false} />
        </Link>

        {/* Mobile Menu Button */}
        <button 
          className={`mobile-menu-btn ${isMenuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation Links */}
        <div className={`navbar-menu ${isMenuOpen ? 'active' : ''}`}>
          <Link to="/" className="navbar-link" onClick={closeMenu}>
            Home
          </Link>
          <Link to="/resources" className="navbar-link" onClick={closeMenu}>
            Resources
          </Link>
          <Link to="/tutorial" className="navbar-link" onClick={closeMenu}>
            Tutorial
          </Link>
          <Link to="/faq" className="navbar-link" onClick={closeMenu}>
            FAQ
          </Link>
          
          {isAuthenticated ? (
            <>
              <Link to="/research" className="navbar-link" onClick={closeMenu}>
                Research
              </Link>
              
              <Link to="/documents" className="navbar-link" onClick={closeMenu}>
                Documents
              </Link>
              <Link to="/gallery" className="navbar-link" onClick={closeMenu}>
                Gallery
              </Link>
              <Link to="/account" className="navbar-link" onClick={closeMenu}>
                Account
              </Link>
              {user && (
                <span className="navbar-user">
                  Welcome, {user.name || user.email}
                </span>
              )}
              <button className="navbar-btn navbar-btn-outline" onClick={handleLogout}>
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="navbar-link" onClick={closeMenu}>
                Login
              </Link>
              <Link to="/register" className="navbar-btn navbar-btn-primary" onClick={closeMenu}>
                Sign Up
              </Link>
            </>
          )}
        </div>
        {/* Overlay for mobile menu */}
        {isMenuOpen && <div className="navbar-overlay" onClick={closeMenu}></div>}
      </div>
    </nav>
  );
};

export default Navbar;
